import i18n from '@/utils/i18n';
import {
  getInfo,
  getAuthList,
  reportHotel,
  getAuthListbackstage,
  onlineChannelIsOpen,
  getRequiredIdResult
} from '@/api/user';
import { getToken, setToken, removeToken, appIdKey } from '@/utils/auth';
import { resetRouter, asyncRoutes, obj, createRouter } from '@/router';
import router from '@/router';
import { filterArray, sortArr, helpJsonParse } from '@/utils/index';
import {
  fetchPrintSettings,
  getBaseInfo,
  fetchServieInfo,
  judgeIsCheckInGrayEnv,
  queryUserHabits,
} from '@/api/systemSet';
const hotelCodeList = ['10666431', '10030921', '10676208', '10668012', '00015198', '10681132', '10677933', '00015198', '00016543', '10666818', '10680943', '10677240', '10227152', '10668304', '10680190', '00016475', '00015117', '10673026', '10681114', '00015723', '00015665', '10676040', '10680970', '10679173', '10668290', '10676208', '10680665', '10676664', '10676482', '10674617', '10680934', '10680827', '10367567', '10679519', '10676979', '10681225', '10675330', '10679698', '10671422', '10668783', '10366475', '10668012', '10681149', '10677944', '10571910', '00015283', '10675037', '10666838', '10680773', '10555505', '10317677', '10669094', '10635319', '10681198', '10301655', '10681043', '10679925', '10676712', '10681102', '10598176', '10671509', '10681014', '10680880', '10674759', '10676178', '10675989', '10675045', '10674002', '10679967', '10675688', '10678537', '00017290', '10668197', '10681031', '10676676', '10678765', '10681238', '10680091', '10679591', '10677939', '10671980', '10676115', '10673605', '00000792', '10680698', '10681148', '10679794', '10681058', '10680641', '10677113', '10668231', '10680986', '10572027', '10680360', '10680262', '10681210', '10677152', '10681193', '10675163', '10676616', '10680643', '10609589', '10677050', '10676943', '10679985', '10680874', '10676545', '10671345', '10585571', '10676165', '10680269', '10680124', '10675991', '10668479', '10681177', '10679108', '10679868', '10680330', '00001495', '10681137', '00000229', '10668847', '10679875', '10666869',
  '10681227', '10681395', '10681254']
import { getHardwareUsedStatus } from '@/api/hardware';
import { getMerchantFunction } from '@/api/merchant';
import { autoAddRouter } from '@/utils/addRoute';
import { getPmscode } from '@/api/goods';
import { cangrayscaleHotel } from '@/api/report';
import Layout from '@/layout';
import config from '@/config';
import Cookies from 'js-cookie';

const appId =
  process.env.NODE_ENV === 'development'
    ? process.env.VUE_APP_BASE_DOMAIN_PREFIX &&
      !process.env.VUE_APP_BASE_DOMAIN_PREFIX.includes('t1')
      ? '461'
      : '1461'
    : getToken(appIdKey);
const state = {
  appIdKey,
  token: getToken('key'),
  name: '',
  userId: '',
  avatar: '',
  mobile: '',
  roles: [],
  authList: [],
  allData: [],
  btnUrlStr: '',
  appName: '',
  appId,
  hotelList: [],
  hotelCode: '',
  hotelName: '',
  hotelLogo: '',
  hotelFrom: '',
  roleAuthList: [],
  userType: '',
  userShifts: helpJsonParse(localStorage.getItem('userShifts')),
  businessDay: localStorage.getItem('businessDay'),
  orderList: [],
  serviceList: [],
  printSettings: null,
  hardwareEnables: [],
  doorCardEnable: undefined,
  isOrderNoticeOpen: true,
  isOrderCancelNoticeOpen: true,
  isAllDayCheckoutOpen: true,
  isHourRoomCheckout: true,
  nightAuditStatus: localStorage.getItem('nightAudit'),
  shiftsList: [],
  showGlobalTip: false,
  reportAuth: '',
  reportAjaxStatus: '',
  isFinMenus: true, // 判断酒店有没有财务对账的数据权限菜单
  serviveInfo: null,
  isCheckInGrayEnv: true, // 是否是散客步入灰度环境
  loginType: null, // 商家or运营
  sassMenuHide: [],
  refresh: 0,
  whetherToOpenADirectChannelConnection: -1,
  routeJumpAddress: '/room-status/real-time',
  //判断当前酒店是否需要必须输入证件证号
  idNumberMustBeEntered: true,
  currentHotelCountryCode: '',
  containerMode: 'modal', // 'modal' 或 'drawer' 'tab' 原页签跳转  originalPageSignature  旧的-- oldNewLabel
};
const mutations = {
  SET_CHECK_IN_GRAY_ENV(state, env) {
    state.isCheckInGrayEnv = env;
  },
  is_there_a_direct_channel_connection(state) {
    if (state.whetherToOpenADirectChannelConnection === -1) {
      onlineChannelIsOpen().then((res) => {
        state.whetherToOpenADirectChannelConnection = res.data;
      });
    }
  },
  SET_DIRECT_CHANNEL_CONNECTION_STATUS(state, status) {
    state.whetherToOpenADirectChannelConnection = status;
  },
  SET_sassMenuHide_INFO(state, info) {
    state.sassMenuHide = info;
  },
  SET_refresh_INFO(state, info) {
    state.refresh = info;
  },
  // 酒店运营信息
  SET_SERVICE_INFO(state, info) {
    state.serviveInfo = info;
  },
  // 酒店所有班次
  SET_SHIFTS_LIST(state, list) {
    state.shiftsList = list;
  },
  // 是否弹停机维护的公告
  SET_GLOBAL_TIP(state, show) {
    state.showGlobalTip = show;
  },
  // 控制夜审弹窗
  SET_NIGHT_AUDIT_STATUS(state, { data, isSetLocalStorage }) {
    if (isSetLocalStorage) {
      localStorage.setItem('nightAudit', data);
    }
    state.nightAuditStatus = data;
  },
  SET_OREDER_NOTICE(state, value) {
    state.isOrderNoticeOpen = value;
  },
  SET_OREDER_CANCEL_NOTICE(state, value) {
    state.isOrderCancelNoticeOpen = value;
  },
  SET_DAY_CHECKOUT_NOTICE(state, value) {
    state.isAllDayCheckoutOpen = value;
  },
  SET_HOUR_CHECKOUT_NOTICE(state, value) {
    state.isHourRoomCheckout = value;
  },
  SET_DOOR_CARD_ENABLE(state, d) {
    state.doorCardEnable = d;
  },
  SET_PRINT_SETTING(state, { data: setting, isSetLocalStorage }) {
    if (setting && Object.prototype.toString.call(setting) === '[object Array]') {
      const tempEnum = {};
      setting.map((item) => {
        const { printTypeCode, sizeTypeCode } = item;
        tempEnum[item.busiTypeCode] = `${sizeTypeCode}-${printTypeCode}`;
      });
      if (isSetLocalStorage) {
        localStorage.setItem('printSettings', JSON.stringify(tempEnum));
      }
      state.printSettings = tempEnum;
    } else {
      if (isSetLocalStorage) {
        localStorage.setItem('printSettings', JSON.stringify(setting));
      }
      state.printSettings = setting;
    }
  },
  SET_USER_TYPE: (state, type) => {
    state.userType = type;
  },
  SET_BUSINESS_DAY: (state, day) => {
    localStorage.setItem('businessDay', day);
    state.businessDay = day;
  },
  SET_SHIFTS: (state, { data: shifts, isSetLocalStorage }) => {
    state.userShifts = shifts;
    if (isSetLocalStorage) {
      localStorage.setItem('userShifts', JSON.stringify(shifts) || null);
    }
  },
  SET_ROLE_AUTHLIST: (state, list) => {
    state.roleAuthList = list;
  },
  SET_HOTEL_FROM: (state, from) => {
    state.hotelFrom = from;
  },
  SET_APPID: (state, appId) => {
    setToken(appId, appIdKey);
    state.appId = appId;
  },
  SET_TOKEN: (state, token) => {
    state.token = token;
    setToken(token);
  },
  SET_NAME: (state, name) => {
    state.name = name;
  },
  SET_USER_ID: (state, id) => {
    state.userId = id;
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar;
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles;
  },
  SET_AUTHLIST: (state, list) => {
    state.authList = list;
  },
  SET_APP_NAME: (state, name) => {
    state.appName = name;
  },
  SET_HOTEL_LIST: (state, list) => {
    state.hotelList = list;
  },
  SET_HOTEL_CODE: (state, code) => {
    localStorage.setItem('hotelCode', code);
    Cookies.set('hotelCode', code, { expires: 60 });
    state.hotelCode = code;
  },
  SET_HOTEL_NAME: (state, code) => {
    state.hotelName = code;
  },
  SET_HOTEL_LOGO: (state, logo) => {
    state.hotelLogo = logo;
  },
  SET_ALL_DATA: (state, list) => {
    state.allData = list;
  },
  SET_BTN_LIST: (state, list) => {
    state.btnUrlStr = list;
  },
  SET_ORDER_LIST: (state, list) => {
    state.orderList = list;
  },
  SET_SERVICE_LIST: (state, list) => {
    state.serviceList = list;
  },
  SET_MOBILE: (state, mobile) => {
    state.mobile = mobile;
  },
  SET_REPORT_AUTH: (state, auth) => {
    state.reportAuth = auth;
  },
  SET_REPORT_AJAX_STATUS: (state, status) => {
    state.reportAjaxStatus = status;
  },
  SET_IS_FIN_MENUS: (state, status) => {
    state.isFinMenus = status;
  },
  SET_LOGIN_TYPE: (state, loginType) => {
    state.loginType = loginType;
  },
  CURRENT_HOTEL_COUNTRY_CODE: (state, code) => {
    state.currentHotelCountryCode = code;
  },
  SET_ROUTE_JUMP_ADDRESS: (state, status) => {
    state.routeJumpAddress = status;
  },
  ID_NUMBER_MUST_BE_ENTERED: (state, status) => {
    state.idNumberMustBeEntered = status == 1;
  },
  SET_TAX_CONFIG: (state, taxConfig) => {
    state.taxConfig = taxConfig;
  },
  // containerMode
  CONSTAINER_MODE(state, info) {
    let array = ['tab', 'modal', 'drawer', 'originalPageSignature', 'oldNewLabel']
    state.containerMode = array[info]
  },

};

const actions = {
  judgeIsCheckInGrayEnvAction({ commit }) {
    return new Promise((resolve) => {
      judgeIsCheckInGrayEnv()
        .then((res) => {
          if (res.code === '0') {
            commit('SET_CHECK_IN_GRAY_ENV', res.data.graySwith);
            resolve();
          }
        })
        .catch(() => {
          commit('SET_CHECK_IN_GRAY_ENV', false);
          resolve(false);
        });
    });
  },
  async getBusinessDay({ state, commit }, force = false) {
    if (!state.businessDay || force) {
      const day = (await getBaseInfo()).data.businessDay;
      commit('SET_BUSINESS_DAY', day);
    }
    return state.businessDay;
  },
  getHotelType({ commit }) {
    return new Promise((resolve, reject) => {
      let res = { code: '0', data: 'qz', msg: '' };

      commit('SET_HOTEL_FROM', res.data);
      resolve(res.data);

      // getPmscode()
      //   .then((res) => {
      //     if (res && res.code === '0') {
      //       commit('SET_HOTEL_FROM', res.data);
      //       resolve(res.data);
      //     }
      //   })
      //   .catch(() => {
      //     resolve('qz');
      //   });
    });
  },

  getAuthList({ commit, state }, to) {
    getRequiredIdResult().then((res) => {
      commit('ID_NUMBER_MUST_BE_ENTERED', res.data);
    });
    return new Promise((resolve, reject) => {
      if (window.location.href.indexOf('from=byh') > -1) {
        var routeList = [
          {
            path: '/customer',
            component: Layout,
            redirect: '/customer/member/member-manage',
            name: 'Customer',
            meta: { title: i18n.t('modulesUser.client'), navMenu: 'Customer' },
            children: [
              {
                path: '/customer/member',
                component: () => import('@/views/customer/member/index'),
                meta: {
                  title: i18n.t('modulesUser.membershipManagement'),
                  navMenu: 'Customer',
                  third: true,
                },
                children: [
                  {
                    path: '/customer/member/member-manage',
                    name: 'MeberManage',
                    component: () => import('@/views/customer/member/member-manage'),
                    meta: {
                      title: i18n.t('modulesUser.singleStoreMemberManagement'),
                      navMenu: 'Customer',
                    },
                  },
                  {
                    path: '/customer/member/activity-manage',
                    name: 'ActivityManage',
                    component: () => import('@/views/customer/member/activity-manage'),
                    meta: {
                      title: i18n.t('modulesUser.storeValueManagement'),
                      navMenu: 'Customer',
                    },
                  },
                  {
                    path: '/customer/member/integral-setting',
                    name: 'IntegralSetting',
                    component: () => import('@/views/customer/member/integral-setting'),
                    meta: {
                      title: i18n.t('modulesUser.singleStorePointsSetting'),
                      navMenu: 'Customer',
                    },
                  },
                  {
                    path: '/customer/member/save-report',
                    name: 'saveReport',
                    component: () => import('@/views/customer/member/save-report'),
                    meta: { title: i18n.t('modulesUser.storeValueReport'), navMenu: 'Customer' },
                  },
                ],
              },
            ],
          },
        ];
        commit('SET_AUTHLIST', routeList);
        resolve([
          {
            path: '/',
            redirect: `${routeList[0].path}`,
            hidden: true,
          },
          ...routeList,
          { path: '*', redirect: '/404', hidden: true },
        ]);
      } else {
        getAuthListbackstage({ appId: state.appId }).then((res) => {
          commit('SET_BTN_LIST', res.data.btnUrlStr);
          getFilterRouter(res.data.resourceList)
            .then((response) => {
              // 处理没数据的情况，以防页面不显示
              var finArr = [
                '/finance/merchant/check-bill',
                '/finance/merchant/quality-check-bill',
                '/finance/merchant/remit-record',
                '/finance/merchant/quality-remit-record',
                '/finance/merchant/charge-list',
                '/finance/merchant/quality-charge-list',
              ];
              if (response) {
                if (finArr.indexOf(to.path) > -1) {
                  var isFinMenus = Boolean(
                    response.find((item) => item.url.split('?')[0] == to.path)
                  );
                  commit('SET_IS_FIN_MENUS', isFinMenus);
                }
                getRouter(response, commit, to, resolve, reject, router, state);
              } else {
                getRouter(res.data.resourceList, commit, to, resolve, reject, router, state);
              }
            })
            .catch(() => {
              // 处理报错的情况，以防页面不显示
              getRouter(res.data.resourceList, commit, to, resolve, reject, router, state);
            });
        });
        // getAuthList({
        //   appId: state.appId,
        // }).then((res) => {

        // });
      }
    });
  },

  // function loadView(view) {
  //   // 路由懒加载
  //   return
  // },
  getDoorCardEnable({ commit, state }) {
    return new Promise((resolve) => {
      getHardwareUsedStatus()
        .then((res) => {
          if (res.code === '0') {
            commit('SET_DOOR_CARD_ENABLE', res.data);
            resolve(res.data);
          }
        })
        .catch((error) => {
          resolve(error);
        });
    });
  },
  // 获取运营信息
  fetchServieInfo({ commit, state }) {
    fetchServieInfo()
      .then((res) => {
        commit('SET_SERVICE_INFO', res.data);
      })
      .catch(() => {
        console.log(i18n.t('modulesUser.failedToObtainOperationInformationProcedure'));
      });
  },
  // 获取打印设置
  getHotelPrintSetting({ commit, state }) {
    return new Promise((resolve) => {
      fetchPrintSettings({
        hotelCode: state.hotelCode,
      })
        .then((res) => {
          if (res.code === '0') {
            commit('SET_PRINT_SETTING', {
              data: res.data,
              isSetLocalStorage: true,
            });
            resolve(res.data);
          }
        })
        .catch((error) => {
          resolve(error);
        });
    });
  },
  // 获取报表导出的权限
  getReportAuth({ commit, state }) {
    return new Promise((resolve, reject) => {
      cangrayscaleHotel()
        .then((res) => {
          if (res.code === '0') {
            commit('SET_REPORT_AUTH', res.data);
            commit('SET_REPORT_AJAX_STATUS', true);
            resolve(res.data);
          } else {
            commit('SET_REPORT_AUTH', false);
            commit('SET_REPORT_AJAX_STATUS', false);
            resolve(false);
          }
        })
        .catch(() => {
          commit('SET_REPORT_AUTH', false);
          commit('SET_REPORT_AJAX_STATUS', false);
          reject(false);
        });
    });
  },
  // get user info
  async getInfo({ commit, state, dispatch }) {
    let hotelCode = localStorage.getItem('hotelCode') || Cookies.get('hotelCode');
    if (hotelCode) {
      // 切换酒店
      try {
        await reportHotel({ hotelCode: hotelCode });
      } catch (e) {
        console.log(e);
      }
    }
    return new Promise((resolve, reject) => {
      if (window.location.href.indexOf('from=byh') > -1) {
        commit('SET_NAME', '');
        commit('SET_AVATAR', '');
        commit('SET_HOTEL_CODE', '');
        commit('SET_HOTEL_NAME', '');
        commit('SET_MOBILE', '');
        resolve();
      } else {
        getInfo()
          .then((res) => {
            if (res.code == 200 || res.code == 0) {
              const {
                loginName = '',
                loginUserNikeName,
                avatar,
                currentHotelCode,
                currentHotelCodeName,
                currentHotelLogo,
                isTagHotel = '',
                loginUserId,
                userType,
                currentHotelCountryCode
              } = res.data;
              commit('SET_NAME', loginUserNikeName);
              commit('SET_USER_ID', loginUserId);
              commit('SET_AVATAR', avatar);
              commit('SET_USER_TYPE', isTagHotel);
              commit('SET_HOTEL_CODE', currentHotelCode);
              commit('SET_HOTEL_NAME', currentHotelCodeName);
              commit('SET_HOTEL_LOGO', currentHotelLogo);
              commit('SET_MOBILE', loginName);
              commit('SET_LOGIN_TYPE', userType);
              commit('CURRENT_HOTEL_COUNTRY_CODE', currentHotelCountryCode);
              // if (hotelCodeList.indexOf(currentHotelCode) == -1) {
              //   commit('CONSTAINER_MODE', 4);
              // } else {
              queryUserHabits({ loginUserId: loginUserId }).then(res => {
                if (res.code == 0) {
                  commit('CONSTAINER_MODE', res.data.navigationMode);
                }
              })
              // }
              try {
                dispatch(
                  'dialingCode/fetchDialingCodeList',
                  false,
                  { root: true }
                )
              } catch (e) {
                console.warn('dialingCode init failed', e)
              }

            }
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      }
    });
  },

  // user logout
  logout({ commit, state }) {
    removeToken('key');
    resetRouter();
    sessionStorage.clear();
    localStorage.clear();
    if (window.opener) {
      window.close();
    } else {
      if (window.location.hostname.includes('easewin')) {
        // 做你想做的事
        window.location.href = `${config.url}/login/easewinIndex?${new Date()}`;
      } else {
        window.location.href = `${config.url}/login/index?${new Date()}`;
      }

      // this.$router.push({
      //   path: '/login/index',
      // });
    }
  },

  // remove token
  resetToken({ commit }) {
    return new Promise((resolve) => {
      commit('SET_TOKEN', '');
      commit('SET_ROLES', []);
      removeToken();
      resolve();
    });
  },
};
/*
 * 递归匹配权限树与路由树
//  * */
// function deepContrast(filterAuthList, asyncRoutes, routeList = []) {
//   let i = JSON.parse(localStorage.getItem('sassMenuHide'));
//   if (state.sassMenuHide.length == 0) {
//     state.sassMenuHide = i;
//   }
//   asyncRoutes.map((pRoute) => {
//     if (state.sassMenuHide.indexOf(pRoute.path) == -1) {
//       if (pRoute.hidden) {
//         routeList.push(pRoute);
//       } else {
//         const authRouteItem = filterAuthList.find((pr) => pRoute.path === pr.url);
//         if (authRouteItem) {
//           // 说明存在对应路由
//           if (pRoute.hasOwnProperty('meta')) {
//             // 如果有meta属性则用权限资源的名称覆盖路由名称
//             pRoute.meta.title = authRouteItem.name;
//             pRoute.urlIndex = authRouteItem.urlIndex;
//           }
//           if (pRoute.children && authRouteItem.children) {
//             // 匹配子路由
//             pRoute.children = deepContrast(authRouteItem.children, pRoute.children);
//           }
//           routeList.push(pRoute);
//         }
//       }
//     }
//   });
//   // filterAuthList.map(item => {
//   //   const pRoute = asyncRoutes.find(pr => pr.path === item.url)
//   //   if (pRoute) { // 说明存在对应路由
//   //     if (pRoute.hasOwnProperty('meta')) { // 如果有meta属性则用权限资源的名称覆盖路由名称
//   //       pRoute.meta.title = item.name
//   //       pRoute.urlIndex = item.urlIndex
//   //     }
//   //     if (item.children && pRoute.children) { // 匹配子路由
//   //       pRoute.children = deepContrast(item.children, pRoute.children)
//   //     }
//   //     routeList.push(pRoute)
//   //   }
//   // })
//   return routeList;
// }

/**
 * 财务对账控制数据权限
 * 哪个有数据显示哪个路由
 */
async function getFilterRouter(authlist) {
  var arr = [
    {
      name: 'simpleCheck',
      path: '/finance/merchant/check-bill',
      type: 'simple',
      title: i18n.t('modulesUser.billReconciliation'),
      isShow: true,
    },
    {
      name: 'qualityCheck',
      path: '/finance/merchant/quality-check-bill',
      type: 'quality',
      title: i18n.t('modulesUser.billReconciliation'),
      isShow: true,
    },
    {
      name: 'simpleRemit',
      path: '/finance/merchant/remit-record',
      type: 'simple',
      title: i18n.t('modulesUser.paymentRecord'),
      isShow: true,
    },
    {
      name: 'qualityRemit',
      path: '/finance/merchant/quality-remit-record',
      type: 'quality',
      title: i18n.t('modulesUser.paymentRecord'),
      isShow: true,
    },
    {
      name: 'simpleCharge',
      path: '/finance/merchant/charge-list',
      type: 'simple',
      title: i18n.t('modulesUser.expenseStatement'),
      isShow: true,
    },
    {
      name: 'qualityCharge',
      path: '/finance/merchant/quality-charge-list',
      type: 'quality',
      title: i18n.t('modulesUser.expenseStatement'),
      isShow: true,
    },
  ];
  await getMerchantFunction().then((res) => {
    arr.map((item) => {
      if (item.type === 'simple') {
        item.isShow = res.data && res.data.simpleCheck;
      } else {
        item.isShow = res.data && res.data.qualityCheck;
      }
    });
    arr.forEach((list) => {
      if (!list.isShow) {
        authlist.map((item, idx) => {
          if (item.url.split('?')[0] == list.path) {
            authlist.splice(idx, 1);
          }
        });
      } else {
        authlist.map((item) => {
          if (item.url === list.path) {
            item.name = list.title;
          }
        });
      }
    });
  });
  return authlist;
}
// 处理散客步入灰度问题
function handlerCheckInGrayEnvRoute(asyncFilterRoutes) {
  const roomStatusProute = asyncFilterRoutes.find((item) => item.path === '/room-status');
  if (roomStatusProute) {
    const checkInRoute = {
      path:
        '/room-status/checkIn/:roomId/:roomNum/:roomTypeName/:roomTypeCode/:isBindLock/:hotelCode',
      name: 'CheckIn',
      props: true,
      meta: {
        title: i18n.t('common.walkIn'),
        navMenu: 'RoomStatus',
        activeMenu: '/room-status/real-time',
        hidden: true,
      },
      component: () => import('@/views/room-status/check-in/newIndex'),
      hidden: true,
    };
    if (state.isCheckInGrayEnv) {
      roomStatusProute.children.push(checkInRoute);
    } else {
      asyncFilterRoutes.push({
        ...checkInRoute,
        meta: { title: i18n.t('common.walkIn') },
        component: () => import('@/views/room-status/check-in/index'),
      });
    }
  }
  return asyncFilterRoutes;
}
/**
 * 重新处理返回的权限
 * @param {*} authlist
 * @param {*} commit
 * @param {*} resolve
 * @param {*} reject
 */
async function getRouter(authlist, commit, to, resolve, reject, router, state) {
  let jumpToTheHomepageWhenJudging = '/room-status/real-time';
  let metaBackendReturns = {};
  let isItDisplayedInSass = 1;
  await authlist.map((item) => {
    if (item.url == '/home-page/index') {
      jumpToTheHomepageWhenJudging = '/home-page/index';
      commit('SET_ROUTE_JUMP_ADDRESS', '/home-page/index');
    }
    item.path = item.url.split('?')[0]; //获取网址
    [item.props, metaBackendReturns, isItDisplayedInSass, item.newpage] = item.url.split('?')[1]
      ? getURLParams(item.url)
      : [undefined, {}, 1, false];
    item.hidden = item.isShow == 0 || isItDisplayedInSass == 0;
    item.parentId = item.newpage ? state.appId : item.parentId;
    item.meta = {
      title: item.name.split('--')[0],
      icon: item.imageUrl ? item.imageUrl : undefined,
      ...metaBackendReturns,
    };
    item.name = item.componentName;
  });
  authlist.map((item) => {
    if (item.parentId == state.appId && !item.newpage) item.component = 'layout';
    else if (item.component == '') {
      item.component = '404';
    }
  });
  commit('SET_APP_NAME', authlist[0].name);
  let routeList = filterArray(authlist)[0].children;
  // console.log(routeList, 'routeListrouteListrouteListrouteList');
  // 匹配路由
  routeList = formatRouterList(routeList);
  routeList = keepBorrowMenuGroup(routeList);
  routeList = ensureAiNoticeDetailRoute(routeList);
  router = createRouter(routeList);
  commit('SET_ALL_DATA', authlist);
  commit('SET_ROLE_AUTHLIST', routeList);
  sortArr(routeList, 'urlIndex', 'children');
  console.log(routeList);
  if (to.path.includes('/account')) {
    const accountRoute = routeList.find((item) => item.path === '/account');
    if (
      accountRoute &&
      accountRoute.children &&
      accountRoute.children.find((item) => item.path === '/account/accountSet/index')
    ) {
      await autoAddRouter(false, true, routeList); // 查询现付账账套列表
    }
  }
  const financeRoute = routeList.find((item) => item.path === '/finance');
  if (
    to.path.includes('/finance') &&
    financeRoute &&
    financeRoute.children &&
    financeRoute.children.find((item) => item.path === '/finance/mangement/index')
  ) {
    await autoAddRouter(true, false, routeList); // 查询财务的账套列表
  }
  routeList.forEach((item) => {
    if (item.children && item.children[0])
      if (item.children && item.children[0]) {
        // 处理重定向的问题，重定向到所拥有子路由权限的第一个路径
        if (['/finance', '/account'].includes(item.path)) {
          const { externalNumber, suitId } = to.query;
          const isAccountSuit = item.path === '/account';
          let targetSuitParentPath = '/account/accountSet/index';
          if (!isAccountSuit) {
            // 如果是应收账
            if (!suitId) {
              targetSuitParentPath = item.children[0].path;
            }
          }
          // 现付账默认跳转到第一个账套页面
          const suitListRoute = item.children.find((cItem) => cItem.path === targetSuitParentPath);
          if (suitListRoute && suitListRoute.children && suitListRoute.children.length) {
            if (externalNumber || suitId) {
              // 跳转特定账套
              const terminalSuitRoute = suitListRoute.children.find((cItem) =>
                cItem.path.endsWith(`/${isAccountSuit ? externalNumber : suitId}`)
              );
              if (terminalSuitRoute) {
                item.redirect = terminalSuitRoute.path;
              } else {
                item.redirect = suitListRoute.children[0].path;
              }
            } else {
              item.redirect = suitListRoute.children[0].path;
            }
          } else {
            handleRouteRedirect(item);
          }
        } else {
          handleRouteRedirect(item);
        }
      }
  });
  commit('SET_AUTHLIST', routeList);
  resolve([
    {
      path: '/',
      redirect: jumpToTheHomepageWhenJudging,
      hidden: true,
    },
    ...handlerCheckInGrayEnvRoute(routeList),
    { path: '*', redirect: '/404', hidden: true },
  ]); // 404 page must be placed at the end !!!
}

/*
 * 处理路由的重定向
 * @param {*} route
 */
function handleRouteRedirect(route) {
  const childrenFirstPath = route.children[0] || {};
  if (childrenFirstPath.children && childrenFirstPath.children.length) {
    route.redirect = childrenFirstPath.children[0].path;
  } else {
    route.redirect = childrenFirstPath.path;
  }
}

/*
 * AI配置分组的默认入口：只在权限资源实际返回的可见子菜单中选择，
 * 优先房型定价配置、其次 AI用量统计，避免重定向到用户没有权限的子菜单。
 * @param {*} aiConfigRoute /ai/config 分组路由
 * @returns 默认子菜单路由
 */
function resolveAiConfigDefaultChild(aiConfigRoute) {
  const visibleChildren = (aiConfigRoute.children || []).filter((item) => item && item.path && !item.hidden);
  return visibleChildren.find((item) => item.path === '/ai/config/price-guardrails') || visibleChildren.find((item) => item.path === '/ai/config/usage') || visibleChildren[0];
}

/*
 * 旧资源重组成 AI配置分组时，只调整本地生成的“房型定价配置”排序值：
 * 可见时排在“AI用量统计”前面；若它继承了旧资源的隐藏状态，则让可见的用量排第一，
 * 避免 /ai 顶层默认跳转和分组内展示落到隐藏子页。后端已有资源的排序信息不做改动。
 * @param {*} aiConfigRoute /ai/config 分组路由
 */
function ensureLegacyAiConfigChildrenOrder(aiConfigRoute) {
  const children = (aiConfigRoute && aiConfigRoute.children) || [];
  const priceGuardrailsRoute = children.find((item) => item && item.path === '/ai/config/price-guardrails');
  const usageRoute = children.find((item) => item && item.path === '/ai/config/usage');
  if (!priceGuardrailsRoute || !usageRoute) {
    return;
  }
  if (priceGuardrailsRoute.hidden) {
    if (!usageRoute.hidden && !(usageRoute.urlIndex < priceGuardrailsRoute.urlIndex)) {
      priceGuardrailsRoute.urlIndex = (usageRoute.urlIndex || 0) + 1;
    }
  } else if (!(priceGuardrailsRoute.urlIndex < usageRoute.urlIndex)) {
    priceGuardrailsRoute.urlIndex = (usageRoute.urlIndex || 0) - 1;
  }
}

function ensureAiNoticeDetailRoute(routeList) {
  const aiRoute = routeList.find((item) => item.path === '/ai');
  if (!aiRoute || !aiRoute.children || !aiRoute.children.length) {
    return routeList;
  }
  aiRoute.meta = {
    ...(aiRoute.meta || {}),
    title: 'AI',
    navMenu: 'AI',
  };
  const routeMap = {};
  // AI配置调整为分组后，价格护栏与用量挂在 /ai/config 的 children 下；
  // 递归收集才能识别嵌套子菜单，而不是只扫描 AI 的直接子级。
  const collectAiRouteMap = (routeItems) => {
    (routeItems || []).forEach((item) => {
      if (!item) {
        return;
      }
      if (item.path) {
        routeMap[item.path] = item;
      }
      if (Array.isArray(item.children) && item.children.length) {
        collectAiRouteMap(item.children);
      }
    });
  };
  collectAiRouteMap(aiRoute.children);
  const noticeCenterRoute = aiRoute.children.find((item) => item.path && item.path.indexOf('/ai/notice') === 0 && item.path.indexOf('/ai/notice/detail') !== 0);

  if (routeMap['/ai/revenue-manager']) {
    routeMap['/ai/revenue-manager'].meta = {
      ...(routeMap['/ai/revenue-manager'].meta || {}),
      title: '收益管家',
      titleKey: 'route.aiRevenueManager',
      navMenu: 'AI',
      icon: 'message',
    };
  }

  if (routeMap['/ai/store-manager-report']) {
    routeMap['/ai/store-manager-report'].meta = {
      ...(routeMap['/ai/store-manager-report'].meta || {}),
      title: '店长报告',
      titleKey: 'route.aiStoreManagerReport',
      navMenu: 'AI',
    };
  }

  if (routeMap['/ai/smart-pricing']) {
    routeMap['/ai/smart-pricing'].meta = {
      ...(routeMap['/ai/smart-pricing'].meta || {}),
      title: '智能定价',
      titleKey: 'route.aiSmartPricing',
      navMenu: 'AI',
    };
  }

  // ===== AI配置分组重组：兼容旧平级资源与新父子结构 =====
  // 旧结构：/ai/config 是页面资源、/ai/usage 是平级页面资源；
  // 新结构：/ai/config 已是带子菜单的分组。两种结构在前端收敛为同一套菜单。
  const nestedPriceGuardrailsRoute = routeMap['/ai/config/price-guardrails'];
  const nestedUsageRoute = routeMap['/ai/config/usage'];
  const legacyUsageIndex = aiRoute.children.findIndex((item) => item && item.path === '/ai/usage');
  const legacyUsageRoute = legacyUsageIndex > -1 ? aiRoute.children[legacyUsageIndex] : null;
  let aiConfigRoute = routeMap['/ai/config'];
  // 后端已按父子结构返回时为 true，此时保留其可见性与排序，只补元信息。
  const isBackendGroup = Boolean(aiConfigRoute && Array.isArray(aiConfigRoute.children) && aiConfigRoute.children.length);
  let isLegacyConfigLeaf = false;

  if (!aiConfigRoute && legacyUsageRoute) {
    // 只有旧用量资源：创建仅承载已返回资源的分组，不为未返回的房型定价配置新增入口。
    aiConfigRoute = {
      path: '/ai/config',
      name: 'AiConfig',
      component: () => import('@/views/ai/config/container'),
      hidden: legacyUsageRoute.hidden,
      urlIndex: legacyUsageRoute.urlIndex,
      meta: { title: 'AI配置', titleKey: 'route.aiConfig', navMenu: 'AI' },
      children: [],
    };
    // 顶替旧用量资源在 AI 子菜单中的位置，保持原排序。
    aiRoute.children.splice(legacyUsageIndex, 1, aiConfigRoute);
    routeMap['/ai/config'] = aiConfigRoute;
  } else if (aiConfigRoute && !isBackendGroup) {
    // 旧配置资源仍是页面叶子：转为可展开分组，生成“房型定价配置”子路由承接原页面与授权语义。
    isLegacyConfigLeaf = true;
  }

  if (aiConfigRoute) {
    aiConfigRoute.meta = {
      ...(aiConfigRoute.meta || {}),
      title: 'AI配置', titleKey: 'route.aiConfig',
      navMenu: 'AI',
    };
    if (isLegacyConfigLeaf) {
      const legacyConfigComponent = aiConfigRoute.component;
      const legacyConfigHidden = aiConfigRoute.hidden;
      aiConfigRoute.children = [
        {
          path: '/ai/config/price-guardrails',
          name: 'AiConfigPriceGuardrails',
          component: legacyConfigComponent,
          hidden: legacyConfigHidden,
          urlIndex: aiConfigRoute.urlIndex,
          meta: { title: '房型定价配置', titleKey: 'aiUsageSync.priceConfig', navMenu: 'AI' },
        },
      ];
      // 父级必须渲染自己的 router-view 承接子页面；不能指向顶层 Layout，否则会重复渲染完整页面框架。
      aiConfigRoute.component = () => import('@/views/ai/config/container');
    }
    // 后端已返回的新子菜单只补标题，不注入未返回资源。
    if (nestedPriceGuardrailsRoute) {
      nestedPriceGuardrailsRoute.meta = {
        ...(nestedPriceGuardrailsRoute.meta || {}),
        title: '房型定价配置', titleKey: 'aiUsageSync.priceConfig',
        navMenu: 'AI',
      };
    }
    if (nestedUsageRoute) {
      nestedUsageRoute.meta = {
        ...(nestedUsageRoute.meta || {}),
        title: 'AI用量统计', titleKey: 'aiUsageSync.title',
        navMenu: 'AI',
      };
    }
    // 只为后端实际返回的知识库资源补多语言标题，不创建新的权限入口。
    const knowledgeRoute = routeMap['/ai/config/hotel-knowledge'];
    if (knowledgeRoute) {
      knowledgeRoute.meta = {
        ...(knowledgeRoute.meta || {}),
        titleKey: 'hotelKnowledge.title',
        navMenu: 'AI',
      };
    }
  }

  // 旧平级用量资源归入分组：优先移动同一个资源对象（保留权限与排序信息），不复制可见入口。
  if (legacyUsageRoute) {
    if (nestedUsageRoute) {
      // 新旧资源同时存在：保留新子菜单，旧资源转为隐藏兼容跳转，避免重复展示。
      legacyUsageRoute.hidden = true;
      legacyUsageRoute.name = 'AiUsageLegacyRedirect';
      legacyUsageRoute.redirect = '/ai/config/usage';
    } else if (aiConfigRoute) {
      // 只有旧用量资源时，分组已顶替旧用量在原数组中的位置，不能再按下标移除；
      // 其余场景旧用量还挂在 AI 平级菜单上，需要先从平级菜单移除再归入分组。
      if (aiRoute.children[legacyUsageIndex] === legacyUsageRoute) {
        aiRoute.children.splice(legacyUsageIndex, 1);
      }
      legacyUsageRoute.path = '/ai/config/usage';
      legacyUsageRoute.name = 'AiConfigUsage';
      legacyUsageRoute.meta = {
        ...(legacyUsageRoute.meta || {}),
        title: 'AI用量统计', titleKey: 'aiUsageSync.title',
        navMenu: 'AI',
      };
      aiConfigRoute.children.push(legacyUsageRoute);
    }
  }

  // 旧 /ai/usage 地址兼容：仅在用量业务资源确实存在时提供隐藏跳转，不创建无权限入口。
  const hasUsageResource = Boolean(nestedUsageRoute) || Boolean(legacyUsageRoute);
  const hasLegacyUsagePath = aiRoute.children.some((item) => item && item.path === '/ai/usage');
  if (hasUsageResource && !hasLegacyUsagePath) {
    aiRoute.children.push({
      path: '/ai/usage',
      name: 'AiUsageLegacyRedirect',
      hidden: true,
      redirect: '/ai/config/usage',
    });
  }

  // 分组子菜单与默认入口在所有子路由组装完成后统一收口。
  if (aiConfigRoute) {
    aiConfigRoute.alwaysShow = true;
    if (!isBackendGroup) {
      ensureLegacyAiConfigChildrenOrder(aiConfigRoute);
      // 分组可见性跟随子菜单：全部子菜单都隐藏时才隐藏分组，不强行展示已隐藏资源。
      aiConfigRoute.hidden = !aiConfigRoute.children.some((item) => item && !item.hidden);
    }
    const defaultChild = resolveAiConfigDefaultChild(aiConfigRoute);
    if (defaultChild) {
      aiConfigRoute.redirect = defaultChild.path;
    }
  }

  // 门店诊断：Demo 页面，若后端权限返回该路由，则补齐 AI 菜单标题与高亮信息。
  if (routeMap['/ai/store-diagnosis']) {
    routeMap['/ai/store-diagnosis'].meta = {
      ...(routeMap['/ai/store-diagnosis'].meta || {}),
      title: '门店诊断',
      titleKey: 'route.aiStoreDiagnosis',
      navMenu: 'AI',
    };
  }

  if (noticeCenterRoute) {
    noticeCenterRoute.meta = {
      ...(noticeCenterRoute.meta || {}),
      title: '消息通知',
      titleKey: 'route.aiNoticeCenter',
      navMenu: 'AI',
    };
    const noticeEntryRoute = aiRoute.children.find((item) => item.path === '/ai/notice-entry');
    if (!noticeEntryRoute) {
      aiRoute.children.push({
        path: '/ai/notice-entry',
        name: 'AiNoticeCenterEntry',
        hidden: true,
        component: () => import('@/views/ai/notice/index'),
        meta: {
          title: '消息通知',
          titleKey: 'route.aiNoticeCenter',
          navMenu: 'AI',
          activeMenu: noticeCenterRoute.path,
        },
      });
    } else {
      noticeEntryRoute.hidden = true;
      noticeEntryRoute.meta = {
        ...(noticeEntryRoute.meta || {}),
        title: '消息通知',
        titleKey: 'route.aiNoticeCenter',
        navMenu: 'AI',
        activeMenu: noticeCenterRoute.path,
      };
    }
  }

  const firstAiMenu = aiRoute.children.find((item) => item && item.path && !item.hidden && ['/ai/revenue-manager', '/ai/smart-pricing', '/ai/store-manager-report', '/ai/store-diagnosis', '/ai/notice', '/ai/config'].includes(item.path));
  aiRoute.redirect = firstAiMenu ? firstAiMenu.path : aiRoute.redirect;

  if (noticeCenterRoute) {
    const hasDetailRoute = aiRoute.children.find((item) => item.path === '/ai/notice/detail');
    if (!hasDetailRoute) {
      aiRoute.children.push({
        path: '/ai/notice/detail',
        name: 'AiNoticeDetail',
        hidden: true,
        component: () => import('@/views/ai/notice/detail'),
        meta: {
          title: '通知详情',
          titleKey: 'route.aiNoticeDetail',
          navMenu: 'AI',
          activeMenu: noticeCenterRoute.path,
        },
      });
    } else {
      hasDetailRoute.hidden = true;
      hasDetailRoute.meta = {
        ...(hasDetailRoute.meta || {}),
        title: '通知详情',
        titleKey: 'route.aiNoticeDetail',
        navMenu: 'AI',
        activeMenu: noticeCenterRoute.path,
      };
    }
  }
  return routeList;
}
// 物品借用下只剩借用记录一个子菜单，侧边栏默认会把父菜单折叠成这一项；保留「物品借用」这一层。权限平台配不了 alwaysShow。
function keepBorrowMenuGroup(routeList) {
  const walk = (list) => {
    if (!Array.isArray(list)) {
      return;
    }
    list.forEach((route) => {
      if (route.path === '/setting/borrow') {
        route.alwaysShow = true;
      }
      walk(route.children);
    });
  };
  walk(routeList);
  return routeList;
}

// 格式化服务端返回的路由列表
function formatRouterList(routerList) {
  var accessedRouters = [];
  routerList.forEach((element) => {
    accessedRouters.push(element);
    if (element.component && element.component !== '') {
      var componentPath = element.component;
      if (element.component.indexOf('layout') != -1) {
        element.component = () => import(/* webpackChunkName: "[request]" */ `@/layout/index`);
      } else {
        element.component = () =>
          import(/* webpackChunkName: "[request]" */ `@/views/${componentPath}`);
      }
      if (element.children && element.children.length > 0) {
        element.children = formatRouterList(element.children);
      }
    }
  });

  return accessedRouters;
}

// 切割字符串携带数据
function getURLParams(url) {
  // 只辨识第一个问号
  const questionMarkIndex = url.indexOf('?');
  const path = questionMarkIndex >= 0 ? url.slice(0, questionMarkIndex) : url;
  const queryString = questionMarkIndex >= 0 ? url.slice(questionMarkIndex + 1) : '';
  // console.log('str:', [path, queryString]); // 调试分割结果
  let str = queryString;

  const searchParams = str.split('&');
  const params = [{}, {}, 1, false];
  let keyPrefix = '';
  let keyValue = '';
  for (const param of searchParams) {
    // const [key, value] = param.split('=');
    const markIndex = param.indexOf('=');
    let key = markIndex >= 0 ? param.slice(0, markIndex) : param;
    let value = markIndex >= 0 ? param.slice(markIndex + 1) : '';
    // console.log('markIndex:', [key, value]); // 调试分割结果

    keyPrefix = key.split('-')[0];
    keyValue = key.split('-')[1];
    // 解码参数值
    if (keyPrefix == 'prop') params[0][keyValue] = value;
    else if (keyPrefix == 'meta') params[1][keyValue] = value;
    else if (key == 'isSassShow' && value === '0') params[2] = 0;
    else if (key == 'type' && value === 'newpage') params[3] = true;
  }
  return params;
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
